// extracted by mini-css-extract-plugin
module.exports = {"Body":"body_Body__CuVnw","table":"body_table__VI_0y"};